import React, { useEffect, useState } from "react";
import { Grid, TextField } from "@material-ui/core";
import { mechanicalWorkTaskStyle } from "features/mechanicalWork/mechanicalWorkTaskStyle";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import CardHeader from "features/mechanicalWork/cardHeader";
import { IconSquareMoney } from "icons";
import { useSelector } from "react-redux";
import { selectIsVendor } from "features/user/userSlice";
import { useUpdateActivityLogMutation } from "features/activity/activitySlice";
import { isVendorEditLocked } from "features/activity/activityConsts";
import NotificationProvider from "components/NotificationProvider";

const PricingDetails = ({ activity }) => {
    const classes = mechanicalWorkTaskStyle();
    const isVendor = useSelector(selectIsVendor);
    const [updateActivityLog] = useUpdateActivityLogMutation();
    const [price, setPrice] = useState(activity?.price ?? 0);
    const vendorLocked = isVendorEditLocked(activity, isVendor);

    useEffect(() => {
        setPrice(activity?.price ?? 0);
    }, [activity?.price]);

    const onSavePrice = async () => {
        const result = await updateActivityLog({
            ...activity,
            status: activity?.activityId,
            price: parseFloat(price) || 0,
            inventoryUsed: null,
        });
        if (result.error) {
            NotificationProvider.error("Failed to update cost");
            setPrice(activity?.price ?? 0);
        } else {
            NotificationProvider.success("Successfully updated cost");
        }
    };

    return (
        <>
            <CardHeader title='Pricing' icon={<IconSquareMoney />} />

            <Grid container spacing={2} className={classes.details}>
                <Authorize profile={permissionProfiles.DASHBOARD.WORKORDER_CLIENT_FILTER}>
                    <Grid item className={classes.detail}>
                        <Grid className={classes.detailLabel}>
                            Activity Cost:
                        </Grid>
                        <Grid>
                            {isVendor && !vendorLocked
                                ? <TextField
                                    type="number"
                                    value={price}
                                    onChange={e => setPrice(e.target.value)}
                                    onBlur={onSavePrice}
                                    size="small"
                                    inputProps={{ min: 0, step: 0.01 }}
                                />
                                : <>{activity?.price ? `$${activity.price}` : "$0"}</>
                            }
                        </Grid>
                    </Grid>
                </Authorize>

                <Authorize profile={permissionProfiles.ACTIVITY.CHARGE_VIEW}>
                    <Grid item className={classes.detail}>
                        <Grid>
                            <Grid className={classes.detailLabel}>
                                Activity Charge:
                            </Grid>
                            <Grid>
                                {activity?.revenue ? `$${activity.revenue}` : "$0"}
                            </Grid>
                        </Grid>
                    </Grid>
                </Authorize>
            </Grid>
        </>)
}

export default PricingDetails;
